const ENVIRONMENT = {
  DEV: 'dev',
  QA: 'qa',
  PROD: 'prod',
};

export default ENVIRONMENT;
